import { modelOptions, prop } from '@typegoose/typegoose';
import mongoose from 'mongoose';
import { AffectedDevice, ScoreBreakdown } from './riskManagement.common.model';

@modelOptions({
  schemaOptions: { collection: 'companyMisconfigurationState' },
  options: { customName: 'companyMisconfigurationState' },
})
export class CompanyMisconfigurationStateModel {
  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true, type: ScoreBreakdown })
  scoreBreakdown: ScoreBreakdown;

  @prop({ required: true, type: AffectedDevice })
  affectedDevices: Array<AffectedDevice>;

  @prop({ required: false })
  indicatorId: number;

  @prop()
  status: number;

  @prop()
  state: number;

  @prop()
  operatingSystem: number;
}
